import type { TableProps } from '@chakra-ui/react'
import { Table as ChakraTable, TableContainer } from '@chakra-ui/react'
import { forwardRef } from 'react'

export interface DashboardTableProps extends TableProps { }

export const Table = forwardRef(
  ({ children, sx, ...rest }: DashboardTableProps, ref) => {
    return (
      <TableContainer sx={{ w: '100%' }}>
        <ChakraTable ref={ref} sx={{ w: '100%', ...sx }} {...rest}>
          {children}
        </ChakraTable>
      </TableContainer>
    )
  },
)
